import React from "react";
// import { render } from "react-dom";
import { NavLink } from "react-router-dom";
import { Modal } from "react-bootstrap";
import IconFaLinkedin from "../img/IconFaLinkedin";
import IconFaMobile from "../img/IconFaMobile";
import IconFaEmail from "../img/IconFaEmail";
import {
	FolioHome,
	FolioIngenio,
	FolioSearch,
	FolioCabin,
	FolioAbout,
	FolioResume,
} from "./AppContent";

class AppNavigation extends React.Component {
	constructor() {
		super();

		// modal state
		this.state = {
			show: false,
		};

		// this.appNav = [
		//   {
		//     id: "01",
		//     linkName: "Overview",
		//     path: "/",
		//     addClassName: "link",
		//   },
		//   {
		//     id: "02",
		//     linkName: "Pharmacy benefits application",
		//     tag01: "IngenioRx",
		//     tag02: "Enterprise applications",
		//     path: "/ingenio-eligibility-application",
		//     addClassName: "link case-study",
		//   },
		//   {
		//     id: "03",
		//     linkName: "Holiday search user-flow",
		//     tag01: "Iglu Cruise",
		//     tag02: "E-commerce",
		//     path: "/iglu-search-holiday",
		//     addClassName: "link case-study",
		//   },
		//   {
		//     id: "04",
		//     linkName: "Select a cabin user-flow",
		//     tag01: "Iglu Cruise",
		//     tag02: "E-commerce",
		//     path: "/iglu-cabin-selection",
		//     addClassName: "link case-study",
		//   },
		//   {
		//     id: "05",
		//     linkName: "Resume",
		//     path: "/resume",
		//     addClassName: "link",
		//   },
		// ];
	}

	handleModal() {
		this.setState({ show: !this.state.show });
		let menuBtn = document.querySelector(".app-nav-btn");
		menuBtn.classList.toggle("active");
	}

	render() {
		// console.log(this.appNav);
		return (
			<>
				<button onClick={() => this.handleModal()} className="app-nav-btn">
					<svg viewBox="-10 0 80 48">
						<path d="M19,15 L45,15 C70,15 58,-2 49.0177126,7 L19,37"></path>
						<path d="M19,24 L45,24 C61.2371586,24 57,49 41,33 L32,24"></path>
						<path d="M45,33 L19,33 C-8,33 6,-2 22,14 L45,37"></path>
					</svg>
				</button>

				<Modal
					show={this.state.show}
					onHide={() => this.handleModal()}
					className="app-nav-modal"
				>
					<nav className="nav">
						{/* <ul className="list">
              {this.appNav.map((appNavParams) => {
                return (
                  <li key={appNavParams.id} className="list-item">
                    <NavLink
                      exact
                      to={appNavParams.path}
                      onClick={() => this.handleModal()}
                      className={appNavParams.addClassName}
                      activeClassName="selected"
                    >
                      {appNavParams.tag01 && appNavParams.tag02 ? (
                        <span className="tags">
                          {appNavParams.tag01 + " // " + appNavParams.tag02}
                        </span>
                      ) : (
                        ""
                      )}
                      <span className="project">{appNavParams.linkName}</span>
                    </NavLink>
                  </li>
                );
              })}
            </ul> */}
						<ul className="list">
							<li className="list-item">
								<NavLink
									exact
									to={FolioHome.path}
									onClick={() => this.handleModal()}
									className={FolioHome.addClassName}
									activeClassName="selected"
								>
									<span className="project">{FolioHome.linkName}</span>
								</NavLink>
							</li>
							<li className="list-item">
								<NavLink
									exact
									to={FolioIngenio.path}
									onClick={() => this.handleModal()}
									className={FolioIngenio.addClassName}
									activeClassName="selected"
								>
									<span className="tags">
										{FolioIngenio.tag01 + " // " + FolioIngenio.tag02}
									</span>
									<span className="project">{FolioIngenio.caseStudy}</span>
								</NavLink>
							</li>
							<li className="list-item">
								<NavLink
									exact
									to={FolioSearch.path}
									onClick={() => this.handleModal()}
									className={FolioSearch.addClassName}
									activeClassName="selected"
								>
									<span className="tags">
										{FolioSearch.tag01 + " // " + FolioSearch.tag02}
									</span>
									<span className="project">{FolioSearch.caseStudy}</span>
								</NavLink>
							</li>
							<li className="list-item">
								<NavLink
									exact
									to={FolioCabin.path}
									onClick={() => this.handleModal()}
									className={FolioCabin.addClassName}
									activeClassName="selected"
								>
									<span className="tags">
										{FolioCabin.tag01 + " // " + FolioCabin.tag02}
									</span>
									<span className="project">{FolioCabin.caseStudy}</span>
								</NavLink>
							</li>
							<li className="list-item">
								<NavLink
									exact
									to={FolioAbout.path}
									onClick={() => this.handleModal()}
									className={FolioAbout.addClassName}
									activeClassName="selected"
								>
									<span className="project">{FolioAbout.linkName}</span>
								</NavLink>
							</li>
							<li className="list-item">
								<NavLink
									exact
									to={FolioResume.path}
									onClick={() => this.handleModal()}
									className={FolioResume.addClassName}
									activeClassName="selected"
								>
									<span className="project">{FolioResume.linkName}</span>
								</NavLink>
							</li>
						</ul>
						<ul className="list contacts">
							<li className="list-item">
								<a
									className="link"
									href="https://www.linkedin.com/in/martinduggan"
									target="_blank"
									rel="noopener noreferrer"
								>
									<IconFaLinkedin />
									Linkedin
								</a>
							</li>
							<li className="list-item">
								<a className="link" href="tel:0014046977037">
									<IconFaMobile />
									(404) ••• ••••
								</a>
							</li>
							<li className="list-item">
								<span className="link">
									<IconFaEmail />
									info@••••.com
								</span>
							</li>
						</ul>
					</nav>
					<button
						className="btn-close"
						onClick={() => {
							this.handleModal();
						}}
					>
						close
					</button>
				</Modal>
			</>
		);
	}
}

export default AppNavigation;
